import CustomModal from "../../../core/components/ui/custom-modal.component"
import EditFunctionForm from "./edit-function-form.component";

const EditFunctionModal = ({row, handleRecordChange, openEdit, setOpenEdit}) => {
    const handleClose = () => setOpenEdit(false);
    
    return(
        <CustomModal  
            open={openEdit}
            handleClose={handleClose}
            title="Edit Function"
        >
            <EditFunctionForm handleClose={handleClose} handleRecordChange={handleRecordChange} row={row}/>
        </CustomModal>
    )
}


export default EditFunctionModal
